/**
 * Convert any string to a URL-safe slug.
 * - Lowercases
 * - Transliterates German umlauts and ß
 * - Strips combining diacritics (NFKD normalize → drop marks)
 * - Replaces remaining non-alphanumeric with hyphens
 * - Collapses repeated hyphens, trims leading/trailing
 *
 * Returns an empty string if nothing usable remains — callers should
 * apply a fallback (e.g. "page-1234") in that case.
 */
export function slugify(input) {
  if (!input) return '';
  let s = String(input).trim().toLowerCase();
  // German digraphs first (so ä → ae, not just a)
  s = s
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');
  // Strip remaining combining diacritics (é → e, ç → c, etc.)
  if (s.normalize) {
    s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
  }
  // Replace anything not a-z / 0-9 with a hyphen
  s = s.replace(/[^a-z0-9]+/g, '-');
  // Collapse + trim hyphens
  s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
  return s;
}
